import AdminModel from "../models/AdminModel"
import { mapMutations, mapState } from "vuex"

export default {
    mixins: [AdminModel],
    data() {
        return {
            completedTourGuides: []
        }
    },
    computed: {
        ...mapState({
            startATSJobPoolOverviewTour: state => state.startATSJobPoolOverviewTour,
            startATSJobPoolApplicationsTour: state => state.startATSJobPoolApplicationsTour,
            startATSJobPoolJobPreferencesTour: state => state.startATSJobPoolJobPreferencesTour,
            startATSJobPoolJobTeamTour: state => state.startATSJobPoolJobTeamTour,
            startKanbanTour: state => state.startKanbanTour,
            startDashboardTour: state => state.startDashboardTour,
            startApplicantOverviewTour: state => state.startApplicantOverviewTour,
            startApplicantProfileTour: state => state.startApplicantProfileTour,
            startApplicantTour: state => state.startApplicantTour,
            isStartTourButtonClicked: state => state.isStartTourButtonClicked,
            startAuditTrailTour: state => state.startAuditTrailTour,
            startAssessmentTour: state => state.startAssessmentTour,
            startPermissionListingTour: state => state.startPermissionListingTour,
            startInterviewNoteListingTour: state => state.startInterviewNoteListingTour,
            startCreateOrEditInterviewNoteTour: state => state.startCreateOrEditInterviewNoteTour,
            startCreateOrEditPermissionTour: state => state.startCreateOrEditPermissionTour,
        }),
    },
    methods: {
        ...mapMutations([
            'SET_ATS_OVERVIEW_TOUR',
            'SET_ATS_APPLICATIONS_TOUR',
            'SET_ATS_PREFERENCES_TOUR',
            'SET_ATS_JOB_TEAM_TOUR',
            'SET_ATS_KANBAN_TOUR',
            'SET_DASHBOARD_TOUR',
            'SET_APPLICANT_OVERVIEW_TOUR',
            'SET_APPLICANT_PROFILE_TOUR',
            'SET_APPLICANT_TOUR',
            'SET_START_TOUR_BUTTON',
            'SET_AUDIT_TRAIL_TOUR',
            'SET_ASSESSMENT_TOUR',
            'SET_PERMISSION_LISTING_TOUR',
            'SET_INTERVIEW_NOTE_LIST_TOUR',
            'SET_CREATE_OR_EDIT_INTERVIEW_NOTE_TOUR',
            'SET_CREATE_OR_EDIT_PERMISSION_TOUR',
        ]),
        TourGuideMixin() {
            return {
                handleTourButtonClick: () => {                    
                    const routeName = this.$route.name
                    if (routeName === 'Admin.Applicants.Overview') {
                        this.SET_ATS_OVERVIEW_TOUR(true)
                    }
                    if (routeName === 'Admin.Applicants.Applications.Step') {
                        this.SET_ATS_APPLICATIONS_TOUR(true)
                    }
                    if (routeName === 'Admin.Applicants.JobPreferences') {
                        this.SET_ATS_PREFERENCES_TOUR(true)
                    }
                    if (routeName === 'Admin.Applicants.JobTeam') {
                        this.SET_ATS_JOB_TEAM_TOUR(true)
                    }                    
                    if (routeName === 'Admin.Applicants.KanbanApplications') {
                        this.SET_ATS_KANBAN_TOUR(true)
                    }
                    if (routeName === 'Admin.Dashboard') {
                        this.SET_DASHBOARD_TOUR(true)
                    }
                    if (routeName === 'Admin.Applicants.CandidateOverview') {
                        this.SET_APPLICANT_OVERVIEW_TOUR(true)
                    }
                    if (routeName === 'Admin.Applicants.CandidateProfile') {
                        this.SET_APPLICANT_PROFILE_TOUR(true)
                    }
                    if (routeName === 'Applicant.Overview') {
                        this.SET_APPLICANT_TOUR(true)
                    }
                    if (routeName === 'Admin.Audit.Trail') {
                        this.SET_AUDIT_TRAIL_TOUR(true)
                    }
                    if (routeName === 'Applicant.Assessments') {
                        this.SET_ASSESSMENT_TOUR(true)
                    }
                    if (routeName === 'Admin.Settings.Permissions') {
                        this.SET_PERMISSION_LISTING_TOUR(true)
                    }
                    if (routeName === 'Admin.Templates.InterviewNotes') {
                        this.SET_INTERVIEW_NOTE_LIST_TOUR(true)
                    }
                    if (routeName === 'Admin.Templates.InterviewNotes.CreateOrEdit') {
                        this.SET_CREATE_OR_EDIT_INTERVIEW_NOTE_TOUR(true)
                    }

                    if (routeName === 'Admin.Settings.Permissions.Edit') {
                        this.SET_CREATE_OR_EDIT_PERMISSION_TOUR(true)
                    }
                    this.SET_START_TOUR_BUTTON(true)
                },
                getOnboardingDetails: () => {
                    return this.AdminModel.getOnboardingDetails()
                        .then((response) => {
                            this.completedTourGuides = Object.keys(this.$helpers.getObjectProperty(response, 'data', []))
                        })
                },
                postOnboardingDetails: (tourSection) => {
                    const payload = {
                        key : tourSection,
                        content : {
                            action_date: this.$moment(new Date()).format('YYYY-MM-DD'),
                            action: 'COMPLETED'
                        },
                    }
                    return this.AdminModel.postOnboardingDetails(payload)              
                },
                isSectionTourGuideViewed: (section) => {
                    return this.completedTourGuides.includes(section)
                },
                isStartTourToShowOnMount: (section) => {
                    return this.TourGuideMixin().getOnboardingDetails().then(() => {
                        return !this.TourGuideMixin().isSectionTourGuideViewed(section)
                    })
                    .catch(() => {
                        return false
                    })
                }
            }
        }
    },
}
